<!-- ngIf: header.isConnected && !connectError -->

<!--desktop button-->
<a id="header-navLink-burger" *ngIf="isLoggedIn && currentEspaceClient" class="header-navLink header-navLink--burger hide-mobile" (click)="displayHeaderMenu = !displayHeaderMenu">
    <span> {{ civilite }} {{ prenom }} {{ nom }} </span>
    <span class="shutdown" data-tag-commander="" [appTagCommander]="'tagCo.header.logout.button'"></span>
    <div *ngIf="displayHeaderMenu" data-ng-include="'modules/pegase/header/profile.tpl.html'">
        <div class="header-subnav">
            <ul>
                <li (click)="togglePasswordChange()" data-tag-commander="" [appTagCommander]="'tagCo.header.changepassword.button'">
                    {{ 'header.menu.changePassword' | i18n }}
                </li>
                <li id="buttonLogout" class="header-subnavLast" data-tag-commander="" [appTagCommander]="'tagCo.header.logout.button'" (click)="toggleLogout()">
                    {{ 'global.disconnectmodal.title' | i18n }}
                    <i class="icon--exit"></i>
                </li>
            </ul>
        </div>
    </div>
    <!-- ngIf: header.showProfile -->
</a>
<!--mobile button-->
<a *ngIf="isLoggedIn && currentEspaceClient" (click)="toggleMobileLeftMenu()" class="header-navLink header-navLink--burger header__menu--buttonRight hide show-mobile" data-header-menu="" data-push="'right'">
    <span class="header-navItem__text-mobile">{{ 'header.menu.title' | i18n }}</span>
</a>

<!-- ngIf: header.isConnected -->
<!-- ngInclude: 'modules/pegase/header/menu.tpl.html' -->
<div *ngIf="currentEspaceClient">
    <div class="hide show-mobile header__menu--right" [ngClass]="{ 'header__menu--opened': displayHeaderMenu }">
        <div class="header__menuTitle" (click)="toggleMobileLeftMenu()">
            <span>{{ 'header.menu.title' | i18n }}</span>
            <span class="icon circle-arrow-icon circle-arrow-icon--right" data-header-menu="" data-push="'right'" data-close="true"></span>
        </div>
        <div class="header__menuContent">
            <ul>
                <li data-header-menu="" data-push="'right'" data-close="true" data-tag-commander="" [appTagCommander]="'tagCo.header.changepassword.button'" (click)="togglePasswordChange()">
                    {{ 'header.menu.changePassword' | i18n }}
                </li>
                <li data-header-menu="" data-push="'right'" data-close="true" data-tag-commander="" [appTagCommander]="'tagCo.header.logout.button'" (click)="toggleLogout(); toggleMobileLeftMenu()">
                    {{ 'global.disconnectmodal.title' | i18n }}
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- end ngIf: header.isConnected -->

<app-password-change-modal [(visibility)]="changePasswordVisibility" (visibilityChange)="toggleNoscroll.emit()"></app-password-change-modal>

<app-validation-modal-component
    [modalTitle]="'header.logout.title'"
    [content]="'header.logout.message'"
    [visibility]="confirmDeconnexion"
    (crossClick)="confirmDeconnexion = false"
    (leftClick)="confirmDeconnexion = false"
    (rightClick)="logout()"
>
</app-validation-modal-component>

<app-simple-message-modal [(visibility)]="sessionExpired" [modalTitle]="'login.expiredsession.title'" [content]="'login.expiredsession.message'" [closeButton]="'global.close'"> </app-simple-message-modal>
